module.exports = __webpack_public_path__ + "static/media/logo_rev.0ac5db92.svg";